<template>
  <div class="step">
    <div class="step__section step__section--niche-card">
      <div class="step__title">
        Карточка ниши&nbsp;
        <Tooltip>
          <template #parent><HelpIcon /></template>
          Создать новую карточку можно в разделе &laquo;Ниши&raquo;, нажав на кнопку
          &laquo;Добавить&raquo;
        </Tooltip>
      </div>
      <NicheCard
        class="step__section--niche-card__card"
        :title="asideDataClone.stepData.step1.niche.name || 'Название ниши'"
        :description="'N Сборных'"
        :icon="asideDataClone.stepData.step1.niche.icon"
        :bg="asideDataClone.stepData.step1.niche.background"
      />
      <Select
        v-model="asideDataClone.stepData.step1.niche"
        :options="asideDataClone.stepData.options.niches"
        :option-text="'name'"
        :option-key="'id'"
        opacity
        label="Ниша"
        placeholder="К какой нише отосится сборная"
      />
    </div>
    <div class="step__section step__section--faculty">
      <div class="step__title">О сборной</div>
      <Input
        v-model="asideDataClone.stepData.step1.name"
        type="text"
        :error="!validations.facultyName.value && asideDataClone.stepData.step1.facultyNameIsDirty"
        :error-message="validations.facultyName.error"
        required
        label="Название сборной"
        placeholder="Укажи название"
      />
      <TreeSelector
        v-model="groupModel"
        :options="groupOptions"
        :declinations="['группа', 'группы', 'групп']"
        only-children
        use-radio
        required
        label="Группа"
        placeholder="Укажи группу"
        search-placeholder="Поиск по группам"
      />
    </div>
    <div class="step__section step__section--tags">
      <div class="step__title">Тег сборной</div>
      <TagIterator
        :tags="asideDataClone.stepData.step1.tags"
        @setTags="asideDataClone.stepData.step1.tags = $event"
      />
    </div>
  </div>
</template>

<script>
import { cloneDeep } from 'lodash';
import Input from '@/components/UiKit/v2/Input';
import TagIterator from '@/components/UiKit/v2/TagIterator';
import NicheCard from '@/components/UiKit/v2/NicheCard';
import Select from '@/components/UiKit/v2/Select';
import TreeSelector from '@/components/UiKit/v2/TreeSelector';
import Tooltip from '@/components/UiKit/v2/Tooltip';
import HelpIcon from '@/components/Icons/HelpIcon';

export default {
  components: {
    HelpIcon,
    TreeSelector,
    Input,
    TagIterator,
    NicheCard,
    Select,
    Tooltip
  },
  props: {
    asideData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      asideDataClone: {}
    };
  },
  computed: {
    stepIsValid() {
      return Object.values(this.validations).every(item => item.value);
    },
    validations() {
      return {
        facultyName: this.validateFacultyName,
        group: {
          value: this.asideData.stepData.step1.group.id !== 0,
          error: ''
        }
      };
    },
    groupOptions() {
      return this.reverseMapGroups(this.asideDataClone.stepData.options.groups);
    },
    groupModel: {
      get() {
        return this.asideDataClone.stepData.step1.group?.id
          ? [this.asideDataClone.stepData.step1.group]
          : [];
      },
      set(value) {
        this.asideDataClone.stepData.step1.group = value.length ? value[0] : undefined;
      }
    },
    validateFacultyName() {
      const result = {
        value: true,
        error: ''
      };
      const facultyNameIsEmpty =
        this.asideData.stepData.step1.name === '' &&
        !this.asideData.stepData.step1.facultyNameIsDirty;
      const facultyNameIsValid = this.asideData.stepData.step1.name.length > 0;

      if (!facultyNameIsValid || facultyNameIsEmpty) {
        result.value = false;
        result.error = 'Введите название сборной';
      }
      return result;
    }
  },
  watch: {
    stepIsValid(value) {
      this.asideDataClone.isValid = value;
    },
    asideDataClone: {
      deep: true,
      handler() {
        this.$emit('update:asideData', this.asideDataClone);
      }
    },
    'asideData.stepData.step1.name'() {
      this.asideDataClone.stepData.step1.facultyNameIsDirty = true;
    }
  },
  created() {
    this.asideDataClone = cloneDeep(this.asideData);
    this.asideDataClone.isValid = this.stepIsValid;
  },
  methods: {
    reverseMapGroups(folders) {
      return folders.map(folder => ({
        id: folder.folder.id,
        name: folder.folder.name,
        children: [
          ...this.reverseMapGroups(folder.childrenFolders),
          ...folder.groupArray.map(group => ({ id: group.id, name: group.name, children: [] }))
        ]
      }));
    }
  }
};
</script>

<style lang="scss" scoped>
@import 'src/style/utils';

.step {
  $screen-sm: 600px;

  &__section--niche-card {
    &__card {
      height: 132px;
      margin-bottom: 16px;
    }
  }

  &__section--faculty {
    .step__date-container {
      display: flex;
      align-items: center;

      .date-input:not(:last-child) {
        margin-right: 20px;
      }

      @include media($screen-sm) {
        flex-direction: column;

        .date-input:not(:last-child) {
          margin-bottom: 24px;
          margin-right: 0;
        }
      }
    }
  }
}
</style>
